module.exports = __webpack_public_path__ + "static/Lato-Light-4ac54dd4f4c6e2a86e21aee167e1a5a1.woff";